<template>
  <div>
    <div class="row g-3 mb-3">
      <div class="col-12 col-md-6">
        <div class="card h-100"><div class="card-body">
          <p class="text-muted small mb-1">Valor médio das consultas (geral)</p>
          <span class="h2 fw-bold">{{ moneyBR(data.average_session_value_all) }}</span>
        </div></div>
      </div>
      <div class="col-12 col-md-6">
        <div class="card h-100"><div class="card-body">
          <p class="text-muted small mb-1">Valor médio das consultas (agendadas)</p>
          <span class="h2 fw-bold">{{ moneyBR(data.average_session_value_scheduled) }}</span>
        </div></div>
      </div>
    </div>

    <div class="row g-3">
      <div class="col-12 col-xl-5">
        <WidgetCard title="Funil (pacientes cadastrados últ. 30d)" :fixed="false">
          <div class="funnel">
            <div
              v-for="(s, i) in funnel"
              :key="i"
              class="funnel-band"
              :style="{ width: bandWidth(s.perc), backgroundColor: color(i) }"
            >
              <span class="funnel-band-label">{{ capitalize(s.step) }}</span>
              <span class="funnel-band-value">
                {{ numberBR(s.count) }} · {{ s.perc }}%
              </span>
            </div>
          </div>
        </WidgetCard>
      </div>

      <div class="col-12 col-xl-7">
        <WidgetCard title="% pacientes com consulta e com cartão (coorte mensal)">
          <ChartLine :data="paymentAndSession" />
        </WidgetCard>
      </div>

      <div class="col-12 col-xl-6">
        <WidgetCard title="Média de sessões por coorte">
          <ChartBar :data="avgSessions" />
        </WidgetCard>
      </div>
      <div class="col-12 col-xl-6">
        <WidgetCard title="Tempo médio até 1ª sessão (coorte)">
          <ChartBar :data="timeToFirst" />
        </WidgetCard>
      </div>
    </div>
  </div>
</template>

<script>
import {
  moneyBR,
  numberBR,
  COLORS,
  singleSeries,
} from "@/utils/dashboardCharts";
import WidgetCard from "./WidgetCard.vue";

export default {
  name: "DashKpis",
  components: { WidgetCard },
  props: { data: { type: Object, required: true } },
  computed: {
    funnel() {
      const steps = this.data.funnel_last_30d || [];
      // Ordem conforme o painel de BI
      const ORDER = [
        "visualizou home",
        "buscou psis",
        "viu um psi",
        "viu calendario",
        "viu horarios",
        "criou sessao",
        "adicionou cartao",
        "concluiu sessao",
      ];
      const idx = (step) => {
        const i = ORDER.indexOf((step || "").toLowerCase());
        return i < 0 ? ORDER.length : i;
      };
      const ordered = [...steps]
        .filter((s) => (s.step || "").toLowerCase() !== "usou cupom")
        .sort((a, b) => idx(a.step) - idx(b.step));
      const home = steps.find(
        (s) => (s.step || "").toLowerCase() === "visualizou home"
      );
      const base = home ? home.count || 0 : ordered.length ? ordered[0].count || 0 : 0;
      return ordered.map((s) => ({
        ...s,
        perc: base ? Math.round(((s.count || 0) / base) * 1000) / 10 : 0,
      }));
    },
    paymentAndSession() {
      const rows = this.data.monthly_payment_and_session_percentage || [];
      const labels = rows.map((r) => r.year_month);
      return {
        labels,
        datasets: [
          {
            label: "% com consulta",
            data: rows.map((r) => Number(r.users_with_appointments_perc)),
            borderColor: COLORS[0],
            backgroundColor: COLORS[0],
            fill: false,
          },
          {
            label: "% com cartão",
            data: rows.map((r) => Number(r.perc_users_with_customer_id)),
            borderColor: COLORS[1],
            backgroundColor: COLORS[1],
            fill: false,
          },
        ],
      };
    },
    avgSessions() {
      return singleSeries(
        this.data.avg_sessions_per_user_by_cohort || [],
        "year_month",
        "avg_sessions",
        "Média de sessões",
        3
      );
    },
    timeToFirst() {
      return singleSeries(
        this.data.time_to_first_session_by_cohort || [],
        "year_month",
        "avg_days_until_first_appointment",
        "Dias até 1ª sessão",
        5
      );
    },
  },
  methods: {
    moneyBR,
    numberBR,
    color(i) {
      return COLORS[i % COLORS.length];
    },
    bandWidth(perc) {
      // largura mínima p/ manter formato de pirâmide legível
      const w = Math.max(Number(perc) || 0, 22);
      return Math.min(w, 100) + "%";
    },
    capitalize(s) {
      return s ? s.charAt(0).toUpperCase() + s.slice(1) : s;
    },
  },
};
</script>

<style scoped>
.funnel {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 4px 0;
}
.funnel-band {
  height: 40px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  color: #fff;
  line-height: 1.1;
  text-align: center;
  overflow: visible;
  white-space: nowrap;
  transition: width 0.3s;
}
.funnel-band:not(:last-child) {
  border-bottom: 1px solid rgba(255, 255, 255, 0.5);
}
.funnel-band-label {
  font-size: 0.78rem;
  font-weight: 700;
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.35);
}
.funnel-band-value {
  font-size: 0.7rem;
  font-weight: 600;
  opacity: 0.95;
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.35);
}
</style>
